import React from 'react';
import PropTypes from 'prop-types';
import { Button, Navbar, NavbarBrand } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import SilaLogo from '../../common/SilaLogo';

import { useApp } from '../../context';

function SidebarMainNavbar({ hideLogoText = false }) {
  const { t } = useTranslation();
  const { updateApp } = useApp();

  const handleToggleSidebar = (e) => {
    e.preventDefault();
    updateApp({ menuVisible: false });
  };

  return (
    <div className="main-navbar">
      <Navbar className="align-items-stretch bg-black flex-md-nowrap p-0" type="light">
        <div className="w-100 bg-primary d-flex">
          <NavbarBrand className="d-flex py-0 m-0" href="/">
            <div className="d-flex align-items-center my-auto">
              <span className="main-logo-container overflow-hidden d-inline-block">
                <SilaLogo id="main-logo" fill="#FFF" width="80" height="42" className="logo" />
              </span>
              {!hideLogoText && (
                <span className="sidebar-hover d-inline-block d-md-block d-lg-inline-block align-middle ms-3 name">
                  {t('console.title')}
                </span>
              )}
            </div>
          </NavbarBrand>
          <Button
            className="toggle-sidebar d-sm-flex d-md-none d-lg-none text-xl"
            onClick={handleToggleSidebar}
          >
            <i className="fas fa-arrow-left align-self-center" />
          </Button>
        </div>
      </Navbar>
    </div>
  );
}

SidebarMainNavbar.propTypes = {
  /**
   * Whether to hide the logo text, or not.
   */
  hideLogoText: PropTypes.bool,
};

export default SidebarMainNavbar;
